import React, { useState, useEffect } from 'react';
import { securitiesAPI } from '../services/api';

const LiveTicker = () => {
  const [securities, setSecurities] = useState([]);

  useEffect(() => {
    const fetchTicker = async () => {
      try {
        const res = await securitiesAPI.getHot(20);
        setSecurities(res.data || []);
      } catch {
        setSecurities([]);
      }
    };
    fetchTicker();
    const interval = setInterval(fetchTicker, 30000);
    return () => clearInterval(interval);
  }, []);

  if (securities.length === 0) return null;

  const items = [...securities, ...securities];

  return (
    <div className="backdrop-blur-md bg-[#121826]/60 border-y border-white/5 overflow-hidden py-2" data-testid="live-ticker">
      <div className="animate-ticker flex whitespace-nowrap">
        {items.map((s, i) => {
          const isUp = (s.change_percent || 0) >= 0;
          return (
            <div key={i} className="inline-flex items-center gap-3 px-6 border-r border-white/5">
              <span className="text-[#F59E0B] font-semibold text-sm font-mono">{s.symbol}</span>
              <span className="text-[#F8FAFC] font-semibold text-sm font-mono">
                B₹{(s.price || 0).toFixed(2)}
              </span>
              <span className={`text-xs font-mono font-medium ${isUp ? 'text-[#10B981]' : 'text-[#EF4444]'}`}>
                {isUp ? '+' : ''}{(s.change_percent || 0).toFixed(2)}%
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LiveTicker;
